import React from 'react'
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';

const TRACKING_ID = "UA-171347678-3"; //
ReactGA.initialize(TRACKING_ID,{
    // debug: true
});

const RouteChangeTracker = ({ history }) => {

    history.listen((location, action) => {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    });

    return <div></div>;
};

export default withRouter(RouteChangeTracker);